export const percentageValue = function(total = 0,percentage = 0){
    const totalValue = total || 0;
    const percentageValue = percentage || 0;
    return parseFloat((totalValue / 100 * percentageValue).toFixed(2))
}